module.exports = __webpack_public_path__ + "sprite.png?faaf96f00d9f3c057e73c66061fca1e0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sprite.png
// module id = 34
// module chunks = 0